import { QueryClient } from 'react-query';

// Shared QueryClient instance. Lives in its own module (instead of inline in
// App.js) so non-hook code — class components, helpers — can prefetch into the
// same cache that <QueryClientProvider> uses.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 10 * 60 * 1000 },
    refetchOnWindowFocus: false,
  },
});

export default queryClient;
